import React from "react";
import moment from "moment";
import { NavLink, useParams } from "react-router-dom";
import { css } from "@emotion/react";
import { useAccountID } from "../../../store/account";
import { useShowID } from "../../../store/show";

export default function PeriodNav({ makeUrl, bounds, canned }) {
    const { report } = useParams();
    const accountID = useAccountID();
    const podcastID = useShowID();
    return (
        <div style={{ textAlign: "right" }}>
            {["day", "week", "month", "quarter", "year"].map(period => {
                const { preferred } = (bounds && canned[period]) || {};

                const root = makeUrl(accountID, podcastID, report, period);
                const to = preferred
                    ? makeUrl(accountID, podcastID, report, period, preferred.key)
                    : root;

                return (
                    <NavLink
                        key={period}
                        css={css`
                            display: inline-block;
                            margin: 0.5em 1em 0.5em 0;
                            text-decoration: none;
                            font-size: 0.8em;
                            &.active {
                                font-weight: bold;
                                border-bottom: 2px solid #069;
                            }
                        `}
                        to={to}
                    >
                        {period}
                    </NavLink>
                );
            })}
        </div>
    );
}
